import { whenProp } from 'remote-com-shared/style/helpers';
import { sharedTransition } from 'remote-com-shared/style/motion';
import styled, { css } from 'styled-components';

export const defaultAnimation = css`
  ${sharedTransition('transform')}
  opacity: 0;
  transform: translateY(100px);

  ${whenProp(
    '$isVisible',
    css`
      opacity: 1;
      transform: translateY(0);
    `
  )}
`;

export const AnimatedSectionWrapper = styled.div`
  ${defaultAnimation}
`;
